import React from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion as MuiAccordion, AccordionSummary, AccordionDetails } from "@mui/material";

interface IProps {
  accordionSummary: React.ReactNode;
  accordionDetails: React.ReactNode;
}
const Accordion: React.FC<IProps> = ({ accordionSummary, accordionDetails }) => (
  <MuiAccordion
    sx={{
      backgroundColor: "transparent",
      marginBottom: "24px",
      "&.Mui-expanded": { marginBottom: "24px !important" },
    }}
  >
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>{accordionSummary}</AccordionSummary>
    <AccordionDetails sx={{ paddingBottom: "36px" }}>{accordionDetails}</AccordionDetails>
  </MuiAccordion>
);

export default Accordion;
